import { buildBenchmarkFiltersPayload } from '../../../utils/buildBenchmarkFiltersPayload';
import { INITIAL_TREND_PAIRING, PROJECT_COMPARISON_REQUESTS, buildComparisonChanges } from '../constants';
import { buildProjectComparisonPayload } from './buildProjectComparisonPayload';

// What the visualizations are told about the pairing. createVisualizationFetchAction
// spreads this over the request body, so each key here is sent at the top level
// next to benchmarkFilters. `comparisonChanges` is left off entirely when no row
// was re-pointed by hand — the match mode alone describes the pairing then.
// pairing: { matchMode, baselineOverrides }, defaulting to how a pairing starts
// out — a caller that has just reset it doesn't have to describe it.
const trendFilters = (pairing) => {
    const { matchMode, baselineOverrides } = pairing || INITIAL_TREND_PAIRING;
    const comparisonChanges = buildComparisonChanges(baselineOverrides);
    return {
        isTrendComparison: true,
        comparisonType: matchMode,
        ...(comparisonChanges ? { comparisonChanges } : {})
    };
};

// The three visualizations the trend view shows. Split out because applying a
// new pairing re-runs exactly these: the participant tables are what the pairing
// is chosen from, not a result of it, so they're left as they are.
export const fetchTrendVisualizations = (props, pairing) => {
    const benchmarkFilters = buildBenchmarkFiltersPayload(props.benchmarkFiltersAnalysis);
    // Comparison spans a leader's whole history, so the date filter doesn't apply.
    delete benchmarkFilters.date;
    const payload = { benchmarkFilters, additonalFilters: trendFilters(pairing) };

    props.getRaterHeatmap(payload);
    props.getSelfVsOthers(payload);
    props.getTopStrengthTopDev(payload);
};

// Everything the trend view is built from: the visualizations above plus the
// first page of each participant list. Both entry points need exactly this set
// — turning the comparison on, and applying new filters while it's on — so
// there's a single thing for the cache flag to guard.
//
// Takes the connected component's props (the five dispatchers plus the filters)
// and the pairing the results should be built from. Marks the results fetched on
// the way out, so the next toggle reuses them; Apply sets that back to false.
export const fetchTrendData = (props, pairing) => {
    fetchTrendVisualizations(props, pairing);

    PROJECT_COMPARISON_REQUESTS.forEach(({ listType, size }) => {
        props.getProjectComparison(buildProjectComparisonPayload({
            benchmarkFiltersAnalysis: props.benchmarkFiltersAnalysis,
            listType,
            from: 0,
            size,
            searchText: '',
            isInitialFetch: true,
        }));
    });

    props.setTrendDataFetched({ value: true });
};
